<template>
    <div class="EditView">
        <router-link class="EditViewButton" @click="$emit('click', $event)" :to="to" v-if="!!to">
            <svg-view name="edit"></svg-view>
        </router-link>
        <div class="EditViewButton" @click="$emit('click', $event)" v-else>
            <svg-view name="edit"></svg-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditView",
    props: {
        to: { type: Object, default: null },
    }
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .EditView;

@{r} {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;

    &:hover {
        opacity: 0.7;
    }

    &Button {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        width: 35px;
        height: 35px;
        padding: 5px;
        border: 1px solid @color-black;
        border-radius: 100%;
        overflow: hidden;
        cursor: pointer;

        svg {
            width: 100%;
            height: 100%;
            display: block;
            transition: fill 0.2s;
            fill: @color-black;
            padding-top: 1px;
        }
    }
}
</style>